module.exports = __webpack_public_path__ + "img/step2.05c9355a.png";